// extracted by mini-css-extract-plugin
export var activeDot = "_5o-c";
export var buttonContainer = "_5o-9";
export var channelButton = "_5o-a";
export var clickable = "_5o-d";
export var content = "_5o-0";
export var contentFull = "_5o-2";
export var contentThird = "_5o-1";
export var contentWrapper = "_5o-7";
export var description = "_5o-5";
export var heightShort = "_5o-f";
export var image = "_5o-3";
export var imageContainer = "_5o-4";
export var selectButton = "_5o-e";
export var spinnerContainer = "_5o-b";
export var titleContent = "_5o-8";
export var titleWrapper = "_5o-6";